<div class="d-md-flex justify-content-center flex-xs-column">
  <ng-content></ng-content>
</div>
